export default {"src":"/_next/static/media/lock.9d011654.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};